import { configureStore } from "@reduxjs/toolkit";
import stateRecordData from "./DynamicRecordReducer";
import columnHidden from "./ColumnHidden/slices";
import dataConnect from "./DataConnect/slices";
import tableView from "./TableView/slices";
import columnModal from "./ColumnModal/slices";
import tableCell from "./TableCell/slices";
import tableDataType from "./TableDataType/slices";
import tableCopyData from "./TableCopyData/slices";
import tableData from "./TableData/slices";
import relationModal from "./RelationModal/slices";
import tableSelect from "./TableSelect/slices";
import common from "./Common/slices";
import tableSearch from "./TableSearch/slices";
import tableHeader from "./TableHeader/slices";
import appTrigger from "./AppTrigger/slices";
import settings from "./Settings/slices";
import thunk from "redux-thunk";

const store = configureStore({
  reducer: {
    stateRecordData: stateRecordData,
    columnHidden: columnHidden,
    dataConnect: dataConnect,
    tableView: tableView,
    columnModal: columnModal,
    tableCell: tableCell,
    tableDataType: tableDataType,
    tableCopyData: tableCopyData,
    tableData: tableData,
    relationModal: relationModal,
    tableSelect: tableSelect,
    common: common,
    tableSearch: tableSearch,
    tableHeader: tableHeader,
    appTrigger: appTrigger,
    settings: settings,
  },
  middleware: [thunk],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
